<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'Software Country'"></cardHead>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-20 p-b-10 row"
        ref="form"
      >
        <formGroup
          :title="'Software'"
          as="select"
          v-model="softwareId"
          :errors="errors"
          :rules="{ required: true }"
          @change="get"
        >
          <template #input>
            <option v-for="item in softwares" :key="item.Id" :value="item.Id">{{
              item.Name
            }}</option>
          </template>
        </formGroup>
      </Form>
      <load-area v-if="data == null"></load-area>
      <dataTable
        :name="'KolayrezCountry'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @unMatch="unMatch($event)"
        @cellClicked="matchShow = $event.data"
        v-if="data != null"
        :rowClassRules="{
          // row style function
          success: (params) => {
            // var numSickDays = params.data;
            return params?.data?.Name1 != null;
          },
          rowClass: (params, select) => {
            // var numSickDays = params.data;
            return params?.data?.Id == select || select == undefined;
          },
        }"
      ></dataTable>
      <match
        v-if="matchShow != null"
        :countries="countries"
        @setCountries="countries = $event"
        :setModel="matchShow"
        @update="$refs.agGrid.changeRow('Id', $event)"
        @close="matchShow = null"
      ></match>
    </div>
  </div>
</template>

<script>
import match from "./match";
export default {
  name: "SoftwareCountry",
  components: { match },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          filter: "agTextColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Code",
          width: 80,
          filter: "agTextColumnFilter",
          field: "Code",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Name",
          filter: "agTextColumnFilter",
          field: "Name",
          flex: 3,
          minWidth: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "P1",
          filter: "agTextColumnFilter",
          field: "P1",
          flex: 1,
          minWidth: 70,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "P2",
          filter: "agTextColumnFilter",
          field: "P2",
          flex: 1,
          minWidth: 70,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "",
          type: "action",
          width: 40,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="far fa-times-circle"></i>',
              emit: "unMatch",
              if: (data) => {
                return data.Name1 != null;
              },
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
        },
      ],
      data: null,
      matchShow: null,
      countries: [],
      softwares: [],
      softwareId: 1,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Softwares`).then((response) => {
      this.softwares = response.data;
    });
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin
        .get(`SoftwareCountriesBySoftwareId/` + this.softwareId)
        .then((response) => {
          this.data = response.data.sort((x) => (x.Name1 == null ? -1 : 2));
        });
    },
    unMatch(item) {
      this.$swal({
        icon: "question",
        title: "Warning",
        text: "Do you want to unmatch the country named " + item.Name + " ?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .post(`SoftwareCountries/Match/`, {
              Id: item.Id,
              CountryId: null,
            })
            .then(() => {
              this.$refs.agGrid.changeRow("Id", {
                ...item,
                Name1: null,
                CountryId: null,
              });
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Country match has been cancelled.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
